import React, { useState, useMemo, useContext, useEffect } from 'react';
import { AuthContext } from '../../App';
import { Box, Typography, Paper, TextField, InputAdornment, Chip, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { setActiveView, navigateTo } from '../../store/slices/uiSlice';
import SearchIcon from '@material-ui/icons/Search';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import SpeedIcon from '@material-ui/icons/Speed';
import RoomIcon from '@material-ui/icons/Room';
import HistoryIcon from '@material-ui/icons/History';
import ModuleGate from '../common/ModuleGate';
import GetAppIcon from '@material-ui/icons/GetApp';
import PrintIcon from '@material-ui/icons/Print';
import FilterListIcon from '@material-ui/icons/FilterList';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { Tooltip, Button, Dialog, DialogContent, DialogActions, CircularProgress, Checkbox } from '@material-ui/core';
import { selectAllVehicles, fetchAllVehicles } from '../../store/slices/vehiclesSlice';
import { selectDrivers } from '../../store/slices/driversSlice';
import { t } from '../../i18n';
import AccidentsPanel from '../Accidents/AccidentsPanel';
import DrivingEventsView from '../Operations/DrivingEventsView';

const useStyles = makeStyles(() => ({
  // Temas claro/escuro do menu Frota, a seguir o tema da barra (avatar):
  // Clássico/Claro → claro, Escuro → escuro. Tokens --fleet-* por data-fleet-theme.
  '@global': {
    // CLÁSSICO — look ORIGINAL (plano, sem a identidade do kit). Mantém-se tal
    // como estava antes dos temas: fundo cinza liso, acento escuro sólido.
    '[data-fleet-theme="classic"]': {
      '--fleet-page': '#f1f5f9',
      '--fleet-card': '#ffffff',
      '--fleet-border': 'rgba(0,0,0,0.06)',
      '--fleet-border-strong': 'rgba(0,0,0,0.08)',
      '--fleet-border-soft': 'rgba(0,0,0,0.04)',
      '--fleet-shadow': '0 1px 3px rgba(0,0,0,0.04)',
      '--fleet-title': '#0f172a',
      '--fleet-text': '#334155',
      '--fleet-strong': '#0f172a',
      '--fleet-muted': '#64748b',
      '--fleet-muted2': '#94a3b8',
      '--fleet-pill-text': '#475569',
      '--fleet-head-bg': '#f8fafc',
      '--fleet-row-even': '#fbfcfd',
      '--fleet-row-hover': '#f8fafc',
      '--fleet-row-even-hover': '#f1f5f9',
      '--fleet-input-bg': '#ffffff',
      '--fleet-input-border': '#e2e8f0',
      '--fleet-input-border-hover': '#cbd5e1',
      '--fleet-focus-border': '#0f172a',
      '--fleet-chip-active-bg': '#f1f5f9',
      '--fleet-accent': '#0f172a',
      '--fleet-accent-fg': '#ffffff',
      '--fleet-accent-border': '#0f172a',
    },
    '[data-fleet-theme="light"]': {
      // Identidade ecooGPS (ui-kit): fundo em gradiente azul-claro (--viewport-bg)
      // + gradiente da marca (--brand-grad) nos botões/títulos.
      '--fleet-page': 'radial-gradient(1200px 620px at 50% -12%, rgba(24,189,238,0.26) 0%, rgba(47,213,150,0.10) 42%, rgba(24,189,238,0) 72%), linear-gradient(180deg, #E2EDFA 0%, #E8EEF6 48%, #EDF1F6 100%)',
      '--fleet-brand-grad': 'linear-gradient(90deg, #58BAE6 0%, #18BDEE 45%, #2FD596 100%)',
      '--fleet-on-brand': '#03121C',
      '--fleet-brand-glow': 'rgba(7,150,204,0.30)',
      '--fleet-card': '#ffffff',
      '--fleet-border': 'rgba(0,0,0,0.06)',
      '--fleet-border-strong': 'rgba(0,0,0,0.08)',
      '--fleet-border-soft': 'rgba(0,0,0,0.04)',
      '--fleet-shadow': '0 1px 3px rgba(0,0,0,0.04)',
      '--fleet-title': '#0f172a',
      '--fleet-text': '#334155',
      '--fleet-strong': '#0f172a',
      '--fleet-muted': '#64748b',
      '--fleet-muted2': '#94a3b8',
      '--fleet-pill-text': '#475569',
      '--fleet-head-bg': '#f8fafc',
      '--fleet-row-even': '#fbfcfd',
      '--fleet-row-hover': '#f8fafc',
      '--fleet-row-even-hover': '#f1f5f9',
      '--fleet-input-bg': '#ffffff',
      '--fleet-input-border': '#e2e8f0',
      '--fleet-input-border-hover': '#cbd5e1',
      '--fleet-focus-border': '#0f172a',
      '--fleet-chip-active-bg': '#f1f5f9',
      '--fleet-accent': '#0f172a',
      '--fleet-accent-fg': '#ffffff',
      '--fleet-accent-border': '#0f172a',
    },
    '[data-fleet-theme="dark"]': {
      '--fleet-page': 'radial-gradient(1200px 620px at 50% -12%, rgba(32,198,244,0.22) 0%, rgba(61,220,151,0.08) 42%, rgba(32,198,244,0) 72%), linear-gradient(180deg, #0C1A2B 0%, #09121F 55%, #070E18 100%)',
      '--fleet-brand-grad': 'linear-gradient(90deg, #6EC1E4 0%, #20C6F4 45%, #3DDC97 100%)',
      '--fleet-on-brand': '#03121C',
      '--fleet-brand-glow': 'rgba(32,198,244,0.35)',
      '--fleet-card': '#122133',
      '--fleet-border': 'rgba(110,193,228,0.16)',
      '--fleet-border-strong': 'rgba(110,193,228,0.22)',
      '--fleet-border-soft': 'rgba(255,255,255,0.05)',
      '--fleet-shadow': '0 2px 12px rgba(0,0,0,0.45)',
      '--fleet-title': '#eaf3fb',
      '--fleet-text': '#c4d3e3',
      '--fleet-strong': '#eaf3fb',
      '--fleet-muted': '#8ba3bb',
      '--fleet-muted2': '#7e95ac',
      '--fleet-pill-text': '#a9bed3',
      '--fleet-head-bg': '#0e1b2b',
      '--fleet-row-even': 'rgba(255,255,255,0.02)',
      '--fleet-row-hover': 'rgba(255,255,255,0.05)',
      '--fleet-row-even-hover': 'rgba(255,255,255,0.07)',
      '--fleet-input-bg': '#0e1b2b',
      '--fleet-input-border': 'rgba(110,193,228,0.22)',
      '--fleet-input-border-hover': 'rgba(110,193,228,0.4)',
      '--fleet-focus-border': '#20c6f4',
      '--fleet-chip-active-bg': 'rgba(32,198,244,0.16)',
      '--fleet-accent': 'rgba(32,198,244,0.20)',
      '--fleet-accent-fg': '#eaf3fb',
      '--fleet-accent-border': 'rgba(32,198,244,0.5)',
    },
  },
  root: {
    flex: 1,
    overflow: 'auto',
    padding: 24,
    background: 'var(--fleet-page, #f1f5f9)',
    transition: 'background 0.25s ease',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: 'var(--fleet-title, #0f172a)',
    letterSpacing: '-0.02em',
  },
  statsBar: {
    display: 'flex',
    gap: 8,
  },
  statPill: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 12px',
    borderRadius: 20,
    background: 'var(--fleet-card, #ffffff)',
    border: '1px solid var(--fleet-border, rgba(0,0,0,0.06))',
    fontSize: '0.75rem',
    fontWeight: 600,
    color: 'var(--fleet-pill-text, #475569)',
  },
  toolbar: {
    display: 'flex',
    gap: 10,
    marginBottom: 16,
    alignItems: 'center',
  },
  searchField: {
    flex: 1,
    maxWidth: 400,
    '& .MuiOutlinedInput-root': {
      borderRadius: 10,
      background: 'var(--fleet-input-bg, #ffffff)',
      fontSize: '0.82rem',
      color: 'var(--fleet-strong, #0f172a)',
      '& fieldset': { borderColor: 'var(--fleet-input-border, #e2e8f0)' },
      '&:hover fieldset': { borderColor: 'var(--fleet-input-border-hover, #cbd5e1)' },
      '&.Mui-focused fieldset': { borderColor: 'var(--fleet-focus-border, #0f172a)', borderWidth: 1 },
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 14px',
      color: 'var(--fleet-strong, #0f172a)',
    },
  },
  filterChip: {
    borderRadius: '8px !important',
    fontWeight: 600,
    fontSize: '0.72rem',
    color: 'var(--fleet-muted, #64748b)',
    '&.MuiChip-outlined': {
      borderColor: 'var(--fleet-input-border, #e2e8f0)',
      background: 'var(--fleet-card, #ffffff)',
    },
    '&.active': {
      background: 'var(--fleet-chip-active-bg, #f1f5f9)',
      borderColor: 'var(--fleet-focus-border, #0f172a)',
      color: 'var(--fleet-strong, #0f172a)',
    },
  },
  tableCard: {
    borderRadius: 14,
    background: 'var(--fleet-card, #ffffff)',
    border: '1px solid var(--fleet-border, rgba(0,0,0,0.06))',
    boxShadow: 'var(--fleet-shadow, 0 1px 3px rgba(0,0,0,0.04))',
    overflow: 'hidden',
  },
  tableHead: {
    background: 'var(--fleet-head-bg, #f8fafc)',
    '& .MuiTableCell-head': {
      fontSize: '0.66rem',
      fontWeight: 700,
      color: 'var(--fleet-muted, #64748b)',
      textTransform: 'uppercase',
      letterSpacing: '0.07em',
      borderBottom: '1px solid var(--fleet-border-strong, rgba(0,0,0,0.08))',
      padding: '10px 12px',
      whiteSpace: 'nowrap',
      background: 'var(--fleet-head-bg, #f8fafc)',
    },
  },
  tableBody: {
    '& .MuiTableRow-root': {
      transition: 'background 0.15s',
    },
    '& .MuiTableRow-root:hover': {
      background: 'var(--fleet-row-hover, #f8fafc)',
    },
    '& .MuiTableRow-root:nth-of-type(even)': {
      background: 'var(--fleet-row-even, #fbfcfd)',
    },
    '& .MuiTableRow-root:nth-of-type(even):hover': {
      background: 'var(--fleet-row-even-hover, #f1f5f9)',
    },
    '& .MuiTableCell-body': {
      fontSize: '0.78rem',
      padding: '10px 12px',
      color: 'var(--fleet-text, #334155)',
      borderBottom: '1px solid var(--fleet-border-soft, rgba(0,0,0,0.04))',
    },
  },
  vehicleIcon: {
    width: 38,
    height: 38,
    borderRadius: 9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  plateText: {
    fontSize: '0.82rem',
    fontWeight: 700,
    color: 'var(--fleet-strong, #0f172a)',
  },
  typeText: {
    fontSize: '0.70rem',
    color: 'var(--fleet-muted, #64748b)',
  },
  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    padding: '4px 10px',
    borderRadius: 6,
    fontSize: '0.68rem',
    fontWeight: 700,
    letterSpacing: '0.02em',
  },
  cellText: {
    fontSize: '0.78rem',
    color: 'var(--fleet-text, #334155)',
  },
  cellSub: {
    fontSize: '0.68rem',
    color: 'var(--fleet-muted2, #94a3b8)',
  },
  speedText: {
    fontSize: '0.78rem',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  emptyState: {
    textAlign: 'center',
    padding: '48px 24px',
  },
}));

function getVehicleStatus(v) {
  const speed = v.speed || v.position?.speed || 0;
  const ignition = v.position?.attributes?.ignition;
  if (speed > 0) return 'moving';
  if (ignition === true || ignition === 'true') return 'idle';
  return 'off';
}

const STATUS_STYLES = {
  moving: { bg: 'rgba(34,197,94,0.10)', color: '#16a34a', dotColor: '#22c55e' },
  idle:   { bg: 'rgba(245,158,11,0.10)', color: '#d97706', dotColor: '#f59e0b' },
  off:    { bg: 'rgba(148,163,184,0.10)', color: '#64748b', dotColor: '#94a3b8' },
};

// Tema do ecrã Frota: segue EXATAMENTE o tema da barra (avatar) — 3 modos
// distintos. CLÁSSICO = look original (plano, sem gradiente do kit);
// CLARO/ESCURO = identidade ecooGPS (fundo em gradiente + marca em gradiente).
function readFleetTheme() {
  try {
    const t = localStorage.getItem('plannerToolbarTheme');
    return t === 'dark' ? 'dark' : t === 'light' ? 'light' : 'classic';
  } catch { return 'classic'; }
}

// Lazy import TachoDriversView
const TachoDriversView = React.lazy(() => import('./TachoDriversView'));

function FleetView({ lang }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  // Segue o tema da barra ao vivo (evento próprio + 'storage').
  const [fleetTheme, setFleetTheme] = useState(readFleetTheme);
  useEffect(() => {
    const sync = () => setFleetTheme(readFleetTheme());
    window.addEventListener('plannerThemeChange', sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener('plannerThemeChange', sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  // Paleta do diálogo de Grupos. O Dialog renderiza num portal (fora da raiz
  // com data-fleet-theme), por isso os tokens CSS não cascateiam até lá —
  // usamos um objeto por tema. Mantém o âmbar como cor-assinatura dos grupos.
  const gp = fleetTheme === 'dark'
    ? { paper: '#0b1522', surface: '#122133', surfaceAlt: '#0e1b2b',
        border: 'rgba(110,193,228,0.16)', borderSoft: 'rgba(255,255,255,0.06)',
        text: '#eaf3fb', textMute: '#9fb3c8', textFaint: '#6b8099',
        rowOn: 'rgba(202,138,4,0.12)', iconOnBg: 'rgba(202,138,4,0.22)', iconOffBg: 'rgba(255,255,255,0.06)',
        footer: '#0e1b2b', btnBg: '#122133', btnBorder: 'rgba(110,193,228,0.22)', btnText: '#c4d3e3',
        accent: '#eab308', accentSoft: 'rgba(202,138,4,0.16)', accentText: '#fde68a', accentBorder: 'rgba(202,138,4,0.55)',
        shadow: '0 24px 64px rgba(0,0,0,0.6)' }
    : { paper: '#f7f7f5', surface: '#ffffff', surfaceAlt: '#fafaf9',
        border: '#e7e5e4', borderSoft: '#f5f5f4',
        text: '#1c1917', textMute: '#78716c', textFaint: '#a8a29e',
        rowOn: '#fffbeb', iconOnBg: '#fef3c7', iconOffBg: '#f5f5f4',
        footer: '#fafaf9', btnBg: '#ffffff', btnBorder: '#d6d3d1', btnText: '#44403c',
        accent: '#ca8a04', accentSoft: '#fef3c7', accentText: '#a16207', accentBorder: '#ca8a04',
        shadow: '0 24px 64px rgba(28,28,28,0.18)' };
  // selectAllVehicles inclui também os desativados (vem do fetchAllVehicles
  // que dispara em baixo). Fallback para list (ativos) enquanto o thunk não
  // resolveu — evita o ecrã ficar vazio na 1ª pintura.
  const vehicles = useSelector(selectAllVehicles);
  const drivers = useSelector(selectDrivers);
  const { token, clientSettings, updateClientSettings, modules } = useContext(AuthContext);
  const tachoEnabled = clientSettings?.useTachograph !== false;
  // Módulo Acidentes — controlado pelo perfil (módulo 'accidents'). Fail-open
  // quando não há lista de módulos (igual ao ModuleGate).
  const hasModule = (m) => !modules || modules.length === 0 || modules.includes(m);
  const canAccidents = hasModule('accidents');
  // Alarmes de velocidade — MOVIDO de Operações para a Frota (variante fuel).
  const canSpeedAlarms = hasModule('speed_alarms');
  const visibleGroupIds = Array.isArray(clientSettings?.visibleGroupIds) ? clientSettings.visibleGroupIds : [];
  // Painel KPI de cisternas/tractores + coluna "Capacidade": DERIVAM de a frota
  // TER cisternas (não da variante). Buscamos o resumo a todos; o endpoint
  // devolve total:0 para frotas sem cisternas (é seguro) e os painéis só
  // aparecem quando total>0. Assim qualquer frota de cisternas ganha o painel,
  // não só a variante fuel.
  const [cisternsSummary, setCisternsSummary] = useState(null);
  useEffect(() => {
    if (!token) return;
    fetch('/planner-api/vehicles/cisterns-summary', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.ok) setCisternsSummary(data); })
      .catch(() => {});
  }, [token]);
  const hasCisternFleet = (cisternsSummary?.total || 0) > 0;

  // Dialog "Filtrar por grupos" — estado local. O dialog vai buscar a
  // lista de grupos ao backend (com counts) quando abre, para evitar
  // hidratar a UI com listas desactualizadas.
  const [groupsOpen, setGroupsOpen] = useState(false);
  const [groupsLoading, setGroupsLoading] = useState(false);
  const [groupsList, setGroupsList] = useState([]);
  const [groupsSelected, setGroupsSelected] = useState(new Set());
  const [groupsSaving, setGroupsSaving] = useState(false);
  const [groupsSearch, setGroupsSearch] = useState('');
  const [groupsDeviceCount, setGroupsDeviceCount] = useState(0);
  // Mapa groupId → nome do grupo, para a coluna "Grupo" da tabela.
  // Carregado uma vez por sessão; mesmo endpoint usado pelo dialog
  // de filtro. Quando vazio, a coluna mostra "—" ou "Grupo #N".
  const [groupNameById, setGroupNameById] = useState({});
  useEffect(() => {
    if (!token) return;
    fetch('/planner-api/vehicles/groups', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data?.groups) return;
        const m = {};
        for (const g of data.groups) m[String(g.id)] = g.name;
        setGroupNameById(m);
      })
      .catch(() => {});
  }, [token]);
  const resolveGroupLabel = React.useCallback((v) => {
    const gid = Number(v?.groupId || 0);
    if (gid <= 0) return null;
    return groupNameById[String(gid)] || `#${gid}`;
  }, [groupNameById]);

  // ── Avatar helpers (mesma paleta do ChatDrawer para consistência) ──
  const DRIVER_PALETTE = ['#3b82f6', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981', '#ef4444', '#14b8a6', '#6366f1'];
  function colorFromName(name) {
    if (!name) return '#64748b';
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return DRIVER_PALETTE[Math.abs(hash) % DRIVER_PALETTE.length];
  }
  function initials(name) {
    if (!name) return '?';
    const parts = String(name).trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  // Dialog "Detalhe da associação Motorista ↔ Veículo"
  const [pairDialog, setPairDialog] = useState(null); // { vehicle }

  // Permite que o chip "Filtro: N" no Header abra directamente o
  // dialog. Header dispara o evento depois de mudar para a Frota.
  useEffect(() => {
    const handler = () => { setFleetTab('vehicles'); openGroupsDialog(); };
    window.addEventListener('openFleetGroupsDialog', handler);
    return () => window.removeEventListener('openFleetGroupsDialog', handler);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const openGroupsDialog = async () => {
    setGroupsOpen(true);
    setGroupsLoading(true);
    try {
      const r = await fetch('/planner-api/vehicles/groups', {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (r.ok) {
        const data = await r.json();
        setGroupsList(data.groups || []);
        setGroupsDeviceCount(data.deviceCount || 0);
        // Se ainda não há filtro guardado (lista vazia no profile),
        // pré-seleccionamos TODOS — o operador vê o estado inicial
        // (tudo visível) e desmarca o que quer esconder.
        const saved = data.visibleGroupIds || [];
        setGroupsSelected(
          saved.length > 0
            ? new Set(saved.map(Number))
            : new Set((data.groups || []).map(g => g.id))
        );
      }
    } catch (e) { console.error('groups fetch failed', e); }
    setGroupsLoading(false);
  };

  const toggleGroup = (id) => {
    setGroupsSelected(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };
  const selectAllGroups = () => setGroupsSelected(new Set(groupsList.map(g => g.id)));
  const clearGroups = () => setGroupsSelected(new Set());
  const invertGroups = () => setGroupsSelected(prev => {
    const next = new Set();
    groupsList.forEach(g => { if (!prev.has(g.id)) next.add(g.id); });
    return next;
  });

  const saveGroups = async () => {
    setGroupsSaving(true);
    try {
      // Convenção: lista vazia = todos visíveis (default). Se o operador
      // marcar TODOS os grupos, persistimos vazio — mantém o tenant em
      // modo "todos" e não há filtro a aplicar no backend.
      const allSelected = groupsList.length > 0 && groupsSelected.size === groupsList.length;
      const payload = allSelected ? [] : Array.from(groupsSelected).map(Number);
      const r = await fetch('/planner-api/clients/me/profile', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ visibleGroupIds: payload }),
      });
      if (r.ok) {
        updateClientSettings(prev => ({ ...(prev || {}), visibleGroupIds: payload }));
        // Refresca a lista de veículos com o novo filtro aplicado.
        dispatch(fetchAllVehicles(token));
        setGroupsOpen(false);
      } else {
        const err = await r.json().catch(() => ({}));
        alert(err?.error || 'Erro ao guardar filtro');
      }
    } catch (e) { console.error(e); alert('Erro de rede'); }
    setGroupsSaving(false);
  };
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  // Filtro Cisternas — só Move Express (chip exclusivo). Quando ON, mostra
  // apenas trailer_cistern + rigid_cistern; inclui automaticamente os
  // desativados (cisternas separadas estão sempre disabled).
  const [cisternsOnly, setCisternsOnly] = useState(false);
  // Filtro por capacidade específica (em m³). null = sem filtro. Quando o
  // operador clica num card do painel KPI (ex.: 25 m³ → 35), filtra
  // automaticamente para essas cisternas. Liga cisternsOnly implícito.
  const [capacityFilter, setCapacityFilter] = useState(null);
  // Toggle "Mostrar desativados". Default OFF — o ecrã abre como sempre
  // (só ativos). Ao ligar, inclui também os v.disabled, marcados visualmente.
  const [showDisabled, setShowDisabled] = useState(false);
  // Refresca a lista completa (ativos + desativados) ao entrar no ecrã.
  // Não toca em `list` (ativos), que continua a ser servido pelo polling para
  // o resto da app. Token vem do localStorage para evitar coupling extra.
  useEffect(() => {
    if (token) dispatch(fetchAllVehicles(token));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  // Default tab depends on whether the tenant uses a tachograph.
  const [fleetTab, setFleetTab] = useState(tachoEnabled ? 'drivers' : 'vehicles');
  // If the preference flips (admin disables tacho), bounce the user off the drivers tab.
  useEffect(() => {
    if (!tachoEnabled && fleetTab === 'drivers') setFleetTab('vehicles');
  }, [tachoEnabled]); // eslint-disable-line

  const [page, setPage] = useState(0);
  const PAGE_SIZE = 50;

  const driverMap = useMemo(() => {
    const map = {};
    drivers.forEach(d => { map[String(d.id)] = d.name; });
    return map;
  }, [drivers]);

  const enrichedVehicles = useMemo(() => {
    return vehicles.map(v => {
      const status = getVehicleStatus(v);
      const speed = v.speed || v.position?.speed || 0;
      const lastUpdate = v.lastUpdate || v.position?.fixTime;
      // Driver name: prefer currentDriver, then tachograph card name (io563), then driverId map
      const attr = v.position?.attributes || {};
      const driverName = v.currentDriver?.name || attr.driverName || attr.io563 || (v.driverId ? (driverMap[String(v.driverId)] || '') : '');
      const driverPhone = v.currentDriver?.phone || '';
      const tachoCard = attr.io449 != null ? (attr.io449 > 0) : null; // true = card inserted
      return { ...v, status, speed, driverName, driverPhone, lastUpdate, tachoCard };
    });
  }, [vehicles, driverMap]);

  const filtered = useMemo(() => {
    let list = enrichedVehicles;
    // Desativados: só aparecem quando o operador liga o toggle OU quando
    // está no modo "Cisternas" (semi-reboques separados estão sempre
    // disabled — esconde-os seria escondê-los todos).
    if (!showDisabled && !cisternsOnly) {
      list = list.filter(v => !v.disabled);
    }
    if (statusFilter !== 'all') {
      list = list.filter(v => v.status === statusFilter);
    }
    if (search.length >= 2) {
      const q = search.toLowerCase();
      list = list.filter(v =>
        (v.plate || '').toLowerCase().includes(q) ||
        (v.name || '').toLowerCase().includes(q) ||
        (v.type || '').toLowerCase().includes(q) ||
        (v.model || '').toLowerCase().includes(q) ||
        (v.driverName || '').toLowerCase().includes(q) ||
        (v.cisternCapacityM3 != null && String(v.cisternCapacityM3).includes(q)) ||
        (resolveGroupLabel(v) || '').toLowerCase().includes(q)
      );
    }
    // Filtro cisternas (Move Express) — só mostra trailer/rigid cisterns.
    // capacityFilter implica cisternsOnly (não faz sentido filtrar por m³
    // em viaturas normais), por isso aplicamos a condição quando QUALQUER
    // dos dois está activo.
    if (cisternsOnly || capacityFilter != null) {
      list = list.filter(v => v.vehicleKind === 'trailer_cistern' || v.vehicleKind === 'rigid_cistern');
    }
    if (capacityFilter != null) {
      list = list.filter(v => Number(v.cisternCapacityM3) === Number(capacityFilter));
    }
    return list;
  }, [enrichedVehicles, search, statusFilter, showDisabled, cisternsOnly, capacityFilter, resolveGroupLabel]);

  // Contagem de desativados (para o chip mostrar quantos há disponíveis).
  const disabledCount = useMemo(
    () => enrichedVehicles.filter(v => v.disabled).length,
    [enrichedVehicles]
  );

  const pagedVehicles = filtered.slice(0, (page + 1) * PAGE_SIZE);

  const counts = useMemo(() => ({
    total: vehicles.length,
    moving: enrichedVehicles.filter(v => v.status === 'moving').length,
    idle: enrichedVehicles.filter(v => v.status === 'idle').length,
    off: enrichedVehicles.filter(v => v.status === 'off').length,
  }), [vehicles, enrichedVehicles]);

  // Move Express — resumo de camiões (tractores). Tractor = qualquer veículo
  // que NÃO é cisterna (trailer/rigid). Repartição por estado (movimento/
  // ralenti/parado), espelhando o card "Frota cisternas".
  const trucksSummary = useMemo(() => {
    if (!hasCisternFleet) return null;
    const tractors = enrichedVehicles.filter(v =>
      v.vehicleKind !== 'trailer_cistern' && v.vehicleKind !== 'rigid_cistern');
    return {
      total: tractors.length,
      moving: tractors.filter(v => v.status === 'moving').length,
      idle: tractors.filter(v => v.status === 'idle').length,
      off: tractors.filter(v => v.status === 'off').length,
    };
  }, [hasCisternFleet, enrichedVehicles]);

  return (
    <Box className={classes.root} data-fleet-theme={fleetTheme}>
      <Box className={classes.header} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <IconButton size="small" onClick={() => dispatch(setActiveView('planner'))} style={{ color: 'var(--fleet-muted, #64748b)' }}>
          <ArrowBackIcon style={{ fontSize: 18 }} />
        </IconButton>
        <Box style={{
          width: 40, height: 40, borderRadius: 11, flexShrink: 0,
          background: 'var(--fleet-brand-grad, linear-gradient(135deg,#22c55e,#16a34a))',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 6px 16px var(--fleet-brand-glow, rgba(34,197,94,0.30))',
        }}>
          <LocalShippingIcon style={{ fontSize: 22, color: 'var(--fleet-on-brand, #fff)' }} />
        </Box>
        <Box style={{ flex: 1, minWidth: 0 }}>
          <Typography className={classes.title} style={{
            fontSize: '1.35rem', lineHeight: 1.1,
            // Clássico (sem --fleet-brand-grad): cai no sólido #0f172a → título
            // escuro normal. Claro/Escuro: gradiente da marca clipado ao texto.
            background: 'var(--fleet-brand-grad, #0f172a)', WebkitBackgroundClip: 'text', backgroundClip: 'text',
            WebkitTextFillColor: 'transparent', color: 'transparent', display: 'inline-block',
          }}>{t(lang, 'fleetOverview')}</Typography>
          <Typography style={{ fontSize: '0.74rem', color: 'var(--fleet-muted, #64748b)', fontWeight: 500, marginTop: 1 }}>
            {filtered.length} {filtered.length === 1 ? (lang === 'pt' ? 'viatura' : 'vehicle') : (lang === 'pt' ? 'viaturas' : 'vehicles')}
            {' · '}{counts.moving} {t(lang, 'moving')}
          </Typography>
        </Box>
        {/* Fleet tabs — hide "Motoristas Tacógrafo" when the tenant doesn't use a tachograph */}
        <Box style={{ display: 'flex', gap: 4, marginRight: 12 }}>
          {[
            tachoEnabled && { id: 'drivers', label: lang === 'pt' ? 'Motoristas Tacógrafo' : 'Tacho Drivers', icon: '👤' },
            { id: 'vehicles', label: lang === 'pt' ? 'Veículos' : 'Vehicles', icon: '🚛' },
            canAccidents && { id: 'accidents', label: lang === 'pt' ? 'Acidentes' : 'Accidents', icon: '🚨' },
            canSpeedAlarms && { id: 'speed-alarms', label: lang === 'pt' ? 'Alarmes de velocidade' : 'Speed alarms', icon: '⚡' },
          ].filter(Boolean).map(tab => (
            <Chip key={tab.id} label={`${tab.icon} ${tab.label}`} size="small"
              onClick={() => setFleetTab(tab.id)}
              style={{
                height: 28, fontSize: '0.7rem', fontWeight: fleetTab === tab.id ? 700 : 500,
                background: fleetTab === tab.id ? 'var(--fleet-brand-grad, #0f172a)' : 'var(--fleet-card, #fff)',
                color: fleetTab === tab.id ? 'var(--fleet-on-brand, #fff)' : 'var(--fleet-pill-text, #475569)',
                border: fleetTab === tab.id ? '1px solid transparent' : '1px solid var(--fleet-input-border, #e2e8f0)',
                cursor: 'pointer',
              }}
            />
          ))}
        </Box>
        <Tooltip title={visibleGroupIds.length > 0
          ? `Filtro activo: ${visibleGroupIds.length} grupo(s) visíveis`
          : 'Escolher grupos EcooGPS visíveis no Planner'}>
          <Button size="small" variant="outlined" startIcon={<FilterListIcon style={{ fontSize: 14 }} />}
            onClick={openGroupsDialog}
            style={{
              fontSize: '0.65rem',
              textTransform: 'none',
              borderRadius: 8,
              marginRight: 6,
              ...(visibleGroupIds.length > 0
                ? { background: 'var(--fleet-brand-grad, #1e40af)', color: 'var(--fleet-on-brand, #fff)', borderColor: 'transparent' }
                : { borderColor: 'var(--fleet-input-border, #e2e8f0)', color: 'var(--fleet-muted, #64748b)' }),
            }}>
            {visibleGroupIds.length > 0 ? `Grupos (${visibleGroupIds.length})` : 'Grupos'}
          </Button>
        </Tooltip>
        <Tooltip title="PDF">
          <Button size="small" variant="outlined" startIcon={<PrintIcon style={{ fontSize: 14 }} />}
            onClick={() => {
              const { jsPDF } = require('jspdf');
              const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'landscape' });
              doc.setFontSize(14); doc.setFont('helvetica', 'bold');
              doc.text('Lista de Veículos — EcooGPS Planner', 14, 16);
              doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(100);
              doc.text(`Gerado em ${new Date().toLocaleString('pt-PT')} · ${filtered.length} veículos`, 14, 22);
              let y = 30;
              // Header
              doc.setFillColor(30, 64, 175); doc.rect(14, y, 269, 7, 'F');
              doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(255);
              ['Matrícula', 'Tipo', 'Grupo', 'Estado', 'Motorista', 'Última posição', 'Velocidade', 'Odómetro'].forEach((h, i) => {
                doc.text(h, 16 + i * 33, y + 5);
              });
              y += 9; doc.setTextColor(30);
              filtered.forEach((v, i) => {
                if (y > 190) { doc.addPage(); y = 20; }
                doc.setFont('helvetica', i % 2 === 0 ? 'normal' : 'normal');
                if (i % 2 === 0) { doc.setFillColor(248, 250, 252); doc.rect(14, y - 3, 269, 6, 'F'); }
                doc.setFontSize(7); doc.setFont('helvetica', 'normal'); doc.setTextColor(30);
                doc.text(v.plate || '-', 16, y);
                doc.text(v.type || '-', 49, y);
                doc.text(resolveGroupLabel(v) || '-', 82, y);
                doc.text(v.status === 'moving' ? 'Em movimento' : v.status === 'idle' ? 'Ralenti' : 'Parado', 115, y);
                doc.text(v.driverName || '-', 148, y);
                doc.text(v.lastUpdate ? new Date(v.lastUpdate).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '-', 181, y);
                doc.text(v.speed > 0 ? `${Math.round(v.speed)} km/h` : '-', 214, y);
                doc.text(v.odometer || '-', 247, y);
                y += 6;
              });
              doc.save(`frota_${new Date().toISOString().slice(0, 10)}.pdf`);
            }}
            style={{ fontSize: '0.65rem', textTransform: 'none', borderColor: 'var(--fleet-input-border, #e2e8f0)', color: 'var(--fleet-muted, #64748b)', borderRadius: 8, marginRight: 6 }}>
            PDF
          </Button>
        </Tooltip>
        <Tooltip title="Excel">
          <Button size="small" variant="outlined" startIcon={<GetAppIcon style={{ fontSize: 14 }} />}
            onClick={() => {
              const headers = ['Matrícula', 'Tipo', 'Grupo', 'Estado', 'Motorista', 'Última posição', 'Velocidade', 'Latitude', 'Longitude'];
              const rows = filtered.map(v => [
                v.plate || '', v.type || '',
                resolveGroupLabel(v) || '',
                v.status === 'moving' ? 'Em movimento' : v.status === 'idle' ? 'Ralenti' : 'Parado',
                v.driverName || '', v.lastUpdate ? new Date(v.lastUpdate).toLocaleString('pt-PT') : '',
                v.speed > 0 ? `${Math.round(v.speed)}` : '0',
                v.position?.latitude?.toFixed(5) || '', v.position?.longitude?.toFixed(5) || '',
              ]);
              const csv = [headers, ...rows].map(r => r.map(c => `"${c}"`).join(',')).join('\n');
              const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a'); a.href = url; a.download = `frota_${new Date().toISOString().slice(0, 10)}.csv`; a.click();
              URL.revokeObjectURL(url);
            }}
            style={{ fontSize: '0.65rem', textTransform: 'none', borderColor: 'var(--fleet-input-border, #e2e8f0)', color: 'var(--fleet-muted, #64748b)', borderRadius: 8 }}>
            Excel
          </Button>
        </Tooltip>
        <Box className={classes.statsBar}>
          <Box className={classes.statPill}>
            <FiberManualRecordIcon style={{ fontSize: 8, color: '#22c55e' }} />
            {counts.moving} {t(lang, 'moving')}
          </Box>
          <Box className={classes.statPill}>
            <FiberManualRecordIcon style={{ fontSize: 8, color: '#f59e0b' }} />
            {counts.idle} {t(lang, 'idle')}
          </Box>
          <Box className={classes.statPill}>
            <FiberManualRecordIcon style={{ fontSize: 8, color: '#94a3b8' }} />
            {counts.off} {t(lang, 'off')}
          </Box>
        </Box>
      </Box>

      {/* Drivers tab */}
      {fleetTab === 'drivers' && (
        <React.Suspense fallback={<Box style={{ padding: 40, textAlign: 'center' }}>A carregar...</Box>}>
          <TachoDriversView lang={lang} />
        </React.Suspense>
      )}

      {/* Acidentes tab — variante fuel (Move Express) */}
      {fleetTab === 'accidents' && canAccidents && (
        <AccidentsPanel lang={lang} />
      )}

      {/* Alarmes de velocidade — MOVIDO de Operações (variante fuel, Move Express) */}
      {fleetTab === 'speed-alarms' && canSpeedAlarms && (
        <DrivingEventsView lang={lang} />
      )}

      {/* Vehicles tab */}
      {fleetTab === 'vehicles' && (<>

      {/* Painel KPI Cisternas — Move Express (distribuição combustível) */}
      {(cisternsSummary?.total > 0 || trucksSummary?.total > 0) && (
      <Box style={{ display: 'flex', gap: 12, flexWrap: 'wrap', margin: '12px 0', alignItems: 'stretch' }}>
      {cisternsSummary && cisternsSummary.total > 0 && (() => {
        const s = cisternsSummary;
        const capCard = (label, count, color, bg, capValue) => {
          const isActive = capacityFilter != null && Number(capacityFilter) === Number(capValue);
          return (
            <Box key={label}
              onClick={() => {
                const next = isActive ? null : capValue;
                setCapacityFilter(next);
                // Cisternas estão maioritariamente como "desativadas" no EcooGPS
                // (sem GPS). Ao clicar num card de capacidade, mostrar
                // automaticamente os desativados para a lista não ficar vazia.
                if (next != null) setShowDisabled(true);
              }}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                padding: '6px 14px', borderRadius: 10,
                background: isActive ? color : bg,
                border: `1.5px solid ${isActive ? color : color + '33'}`,
                minWidth: 80, cursor: 'pointer',
                boxShadow: isActive ? `0 2px 8px ${color}55` : 'none',
                transition: 'all 0.12s ease',
              }}
              title={lang === 'pt'
                ? `Clica para filtrar a tabela pelas cisternas de ${label}`
                : `Click to filter the table by ${label} cisterns`}
            >
              <Typography style={{
                fontSize: '0.6rem', fontWeight: 800,
                color: isActive ? '#fff' : color,
                textTransform: 'uppercase', letterSpacing: 0.5,
              }}>
                {label}
              </Typography>
              <Typography style={{
                fontSize: '1.05rem', fontWeight: 800,
                color: isActive ? '#fff' : '#0f172a',
                lineHeight: 1.1,
                fontFamily: 'ui-monospace, Menlo, monospace',
              }}>
                {count}
              </Typography>
            </Box>
          );
        };
        // Mapa de cores por capacidade (consistente com paleta da frota)
        const CAP_COLORS = {
          '20m3': { color: '#7c3aed', bg: '#f5f3ff' },
          '25m3': { color: '#0284c7', bg: '#e0f2fe' },
          '35m3': { color: '#ea580c', bg: '#ffedd5' },
          '50m3': { color: '#dc2626', bg: '#fee2e2' },
        };
        // Ordena capacidades crescente
        const capEntries = Object.entries(s.byCapacity || {})
          .sort((a, b) => parseInt(a[0]) - parseInt(b[0]));
        return (
          <Box style={{
            flex: '1 1 380px', minWidth: 260, padding: '12px 14px', borderRadius: 12,
            background: 'linear-gradient(135deg, #fff7ed 0%, #ffffff 60%)',
            border: '1px solid #fed7aa',
            display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
          }}>
            <Box style={{
              display: 'flex', flexDirection: 'column',
              borderRight: '1px solid rgba(0,0,0,0.08)', paddingRight: 14, minWidth: 130,
            }}>
              <Typography style={{
                fontSize: '0.66rem', fontWeight: 800, color: '#9a3412',
                textTransform: 'uppercase', letterSpacing: 0.6,
              }}>
                ⛽ {lang === 'pt' ? 'Frota cisternas' : 'Cistern fleet'}
              </Typography>
              <Typography style={{ fontSize: '1.3rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.1, fontFamily: 'ui-monospace, Menlo, monospace' }}>
                {s.total}
              </Typography>
              <Typography style={{ fontSize: '0.62rem', color: '#78716c', marginTop: 2 }}>
                {s.totalTrailers} {lang === 'pt' ? 'reboque' : 'trailer'}{s.totalTrailers !== 1 ? 's' : ''}
                {' · '}
                {s.totalRigids} {lang === 'pt' ? 'rígido' : 'rigid'}{s.totalRigids !== 1 ? 's' : ''}
              </Typography>
            </Box>
            <Box style={{ display: 'flex', gap: 8, flexWrap: 'wrap', flex: 1 }}>
              {capEntries.map(([cap, count]) => {
                const c = CAP_COLORS[cap] || { color: '#475569', bg: '#f1f5f9' };
                const capValue = parseInt(cap); // "35m3" → 35
                return capCard(cap.replace('m3', ' m³'), count, c.color, c.bg, capValue);
              })}
            </Box>
          </Box>
        );
      })()}

      {/* Card "Frota camiões" (só Move Express) — total de tractores +
          repartição por estado. Espelha o card das cisternas. Clicar num
          estado filtra a tabela por esse estado. */}
      {trucksSummary && trucksSummary.total > 0 && (() => {
        const st = trucksSummary;
        const stCard = (key, label, count, color, bg) => {
          const isActive = statusFilter === key;
          return (
            <Box key={key}
              onClick={() => setStatusFilter(isActive ? 'all' : key)}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                padding: '6px 14px', borderRadius: 10,
                background: isActive ? color : bg,
                border: `1.5px solid ${isActive ? color : color + '33'}`,
                minWidth: 92, cursor: 'pointer',
                boxShadow: isActive ? `0 2px 8px ${color}55` : 'none',
                transition: 'all 0.12s ease',
              }}
              title={lang === 'pt'
                ? `Clica para filtrar a tabela por "${label}"`
                : `Click to filter the table by "${label}"`}
            >
              <Typography style={{
                fontSize: '0.6rem', fontWeight: 800,
                color: isActive ? '#fff' : color,
                textTransform: 'uppercase', letterSpacing: 0.5,
              }}>
                {label}
              </Typography>
              <Typography style={{
                fontSize: '1.05rem', fontWeight: 800,
                color: isActive ? '#fff' : '#0f172a',
                lineHeight: 1.1, fontFamily: 'ui-monospace, Menlo, monospace',
              }}>
                {count}
              </Typography>
            </Box>
          );
        };
        return (
          <Box style={{
            flex: '1 1 380px', minWidth: 260, padding: '12px 14px', borderRadius: 12,
            background: 'linear-gradient(135deg, #eff6ff 0%, #ffffff 60%)',
            border: '1px solid #bfdbfe',
            display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
          }}>
            <Box style={{
              display: 'flex', flexDirection: 'column',
              borderRight: '1px solid rgba(0,0,0,0.08)', paddingRight: 14, minWidth: 130,
            }}>
              <Typography style={{
                fontSize: '0.66rem', fontWeight: 800, color: '#1e40af',
                textTransform: 'uppercase', letterSpacing: 0.6,
              }}>
                🚛 {lang === 'pt' ? 'Frota camiões' : 'Truck fleet'}
              </Typography>
              <Typography style={{ fontSize: '1.3rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.1, fontFamily: 'ui-monospace, Menlo, monospace' }}>
                {st.total}
              </Typography>
              <Typography style={{ fontSize: '0.62rem', color: '#64748b', marginTop: 2 }}>
                {lang === 'pt' ? 'tractores' : 'tractors'}
              </Typography>
            </Box>
            <Box style={{ display: 'flex', gap: 8, flexWrap: 'wrap', flex: 1 }}>
              {stCard('moving', lang === 'pt' ? 'Em movimento' : 'Moving', st.moving, '#16a34a', '#dcfce7')}
              {stCard('idle', lang === 'pt' ? 'Ralenti' : 'Idle', st.idle, '#d97706', '#fef3c7')}
              {stCard('off', lang === 'pt' ? 'Parados' : 'Off', st.off, '#64748b', '#f1f5f9')}
            </Box>
          </Box>
        );
      })()}
      </Box>
      )}

      {/* Toolbar */}
      <Box className={classes.toolbar}>
        <TextField
          variant="outlined"
          size="small"
          placeholder={t(lang, 'searchFleet')}
          value={search}
          onChange={e => setSearch(e.target.value)}
          className={classes.searchField}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ fontSize: 18, color: 'var(--fleet-muted2, #94a3b8)' }} />
              </InputAdornment>
            ),
          }}
        />
        {['all', 'moving', 'idle', 'off'].map(s => (
          <Chip
            key={s}
            label={s === 'all' ? t(lang, 'allStatuses') : `${t(lang, s)} (${counts[s]})`}
            variant="outlined"
            size="small"
            onClick={() => setStatusFilter(s)}
            className={`${classes.filterChip} ${statusFilter === s ? 'active' : ''}`}
          />
        ))}
        {/* Toggle "Mostrar desativados" — só visual (não entra em operações).
            Aparece sempre que houver desativados na frota. Em estado ativo,
            o chip fica cinzento-escuro (distinto dos status, que ficam azuis). */}
        {disabledCount > 0 && (
          <Chip
            label={`${lang === 'pt' ? 'Desativados' : 'Disabled'} (${disabledCount})`}
            variant="outlined"
            size="small"
            onClick={() => setShowDisabled(v => !v)}
            className={`${classes.filterChip} ${showDisabled ? 'active' : ''}`}
            style={showDisabled ? { background: '#475569', color: '#fff', borderColor: '#475569' } : { color: 'var(--fleet-muted, #64748b)' }}
            title={lang === 'pt'
              ? 'Incluir veículos desativados na lista (só visual — não entram em operações)'
              : 'Include disabled vehicles in the list (visual only — not for operations)'}
          />
        )}
        {/* Chip "Cisternas" — só Move Express. Mostra apenas trailer/rigid
            cisterns (108 no total). Activa automaticamente "Mostrar
            desativados" porque cisternas separadas estão sempre disabled. */}
        {cisternsSummary?.total > 0 && (() => {
          const cisternActive = cisternsOnly || capacityFilter != null;
          const label = capacityFilter != null
            ? `🛢 ${capacityFilter} m³`
            : `🛢 ${lang === 'pt' ? 'Cisternas' : 'Cisterns'} (${cisternsSummary.total})`;
          return (
            <Chip
              label={label}
              variant="outlined"
              size="small"
              onClick={() => {
                // Toggle: desliga AMBOS (cisternsOnly + capacityFilter)
                if (cisternActive) {
                  setCisternsOnly(false);
                  setCapacityFilter(null);
                } else {
                  setCisternsOnly(true);
                  // Mostrar desativados auto — senão lista fica vazia.
                  setShowDisabled(true);
                }
              }}
              onDelete={capacityFilter != null ? () => setCapacityFilter(null) : undefined}
              className={`${classes.filterChip} ${cisternActive ? 'active' : ''}`}
              style={cisternActive
                ? { background: '#ea580c', color: '#fff', borderColor: '#ea580c' }
                : { color: '#9a3412', borderColor: '#fed7aa' }}
              title={lang === 'pt'
                ? (capacityFilter != null
                    ? `Filtro activo: cisternas de ${capacityFilter} m³ — clica para limpar`
                    : 'Mostrar apenas cisternas (reboques + rígidos com cisterna fixa)')
                : 'Show only cisterns'}
            />
          );
        })()}
      </Box>

      {/* Table */}
      <Paper elevation={0} className={classes.tableCard}>
        {filtered.length === 0 ? (
          <Box className={classes.emptyState}>
            <LocalShippingIcon style={{ fontSize: 40, color: 'var(--fleet-muted2, #d1d5db)' }} />
            <Typography style={{ fontSize: '0.82rem', color: 'var(--fleet-muted2, #94a3b8)', marginTop: 8 }}>
              {t(lang, 'noVehiclesFound')}
            </Typography>
          </Box>
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell style={{ width: 48 }} />
                  <TableCell>{t(lang, 'vehicle')}</TableCell>
                  <TableCell>{t(lang, 'type')}</TableCell>
                  <TableCell>{lang === 'pt' ? 'Grupo' : 'Group'}</TableCell>
                  <TableCell>{t(lang, 'status')}</TableCell>
                  <TableCell>{t(lang, 'driver')}</TableCell>
                  <TableCell>{t(lang, 'lastUpdate')}</TableCell>
                  <TableCell align="right">{t(lang, 'speed')}</TableCell>
                  <TableCell align="right" style={{ width: 90 }} />
                </TableRow>
              </TableHead>
              <TableBody className={classes.tableBody}>
                {pagedVehicles.map((v, i) => {
                  const st = STATUS_STYLES[v.status];
                  // Veículo desativado — opacidade reduzida + selo cinzento ao
                  // lado da matrícula. Mantém-se na tabela, mas comunica
                  // visualmente que NÃO está disponível para operações.
                  const isDisabled = !!v.disabled;
                  return (
                    <TableRow key={v.id || i} hover style={isDisabled ? { opacity: 0.6 } : undefined}>
                      <TableCell>
                        <Box className={classes.vehicleIcon} style={{ background: st.bg, width: 32, height: 32 }}>
                          <LocalShippingIcon style={{ fontSize: 16, color: st.color }} />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <Box style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <Typography className={classes.plateText}>{v.plate || v.name || '—'}</Typography>
                            {/* Pílula "MOVEL V13" — código interno da viatura
                                Move Express (confirmado no documento real do
                                cliente: NOME MOTORISTA | EMPRESA | MOVEL | …). */}
                            {hasCisternFleet && v.name && v.name !== v.plate && (
                              <span style={{
                                fontSize: '0.56rem', fontWeight: 800,
                                background: '#fff7ed', color: '#9a3412',
                                border: '1px solid #fed7aa',
                                padding: '2px 7px', borderRadius: 999,
                                textTransform: 'uppercase', letterSpacing: '0.04em',
                                fontFamily: 'ui-monospace, Menlo, monospace',
                              }} title="Código interno da viatura (Móvel)">
                                {v.name}
                              </span>
                            )}
                            {isDisabled && (
                              <span style={{
                                fontSize: '0.54rem', fontWeight: 700,
                                background: '#475569', color: '#fff',
                                padding: '2px 6px', borderRadius: 4,
                                textTransform: 'uppercase', letterSpacing: '0.04em',
                              }}>
                                {lang === 'pt' ? 'Desativado' : 'Disabled'}
                              </span>
                            )}
                          </Box>
                          {/* Sub-label com `name` (quando diferente da plate) +
                              `model`. Útil para cisternas onde model traz
                              "SEMI-REBOQUE CISTERNA 35M3" (de onde sai a
                              capacidade via regex). */}
                          {((v.name && v.name !== v.plate) || v.model) && (
                            <Typography style={{
                              fontSize: '0.6rem', color: 'var(--fleet-muted2, #94a3b8)', fontWeight: 500,
                              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                              maxWidth: 260,
                            }} title={[v.name, v.model].filter(Boolean).join(' · ')}>
                              {[v.name && v.name !== v.plate ? v.name : null, v.model].filter(Boolean).join(' · ')}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <Typography style={{ fontSize: '0.74rem', color: 'var(--fleet-muted, #64748b)' }}>{v.type || '—'}</Typography>
                          {/* Pílula de cisterna — mostra a tipologia + capacidade m³ */}
                          {(v.vehicleKind === 'trailer_cistern' || v.vehicleKind === 'rigid_cistern') && (
                            <span style={{
                              display: 'inline-flex', alignItems: 'center', gap: 3,
                              padding: '2px 7px', borderRadius: 8,
                              background: v.vehicleKind === 'trailer_cistern' ? '#fee2e2' : '#fef3c7',
                              color: v.vehicleKind === 'trailer_cistern' ? '#991b1b' : '#92400e',
                              border: `1px solid ${v.vehicleKind === 'trailer_cistern' ? '#fecaca' : '#fcd34d'}`,
                              fontSize: '0.6rem', fontWeight: 800, letterSpacing: 0.3,
                            }} title={v.vehicleKind === 'trailer_cistern'
                                ? (lang === 'pt' ? 'Reboque cisterna (sem GPS)' : 'Trailer cistern (no GPS)')
                                : (lang === 'pt' ? 'Camião com cisterna fixa' : 'Rigid with fixed cistern')}>
                              🛢 {v.cisternCapacityM3 != null ? `${v.cisternCapacityM3}m³` : '?'}
                            </span>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {(() => {
                          const label = resolveGroupLabel(v);
                          if (!label) return <span style={{ color: 'var(--fleet-muted2, #cbd5e1)', fontSize: '0.74rem' }}>—</span>;
                          return (
                            <span style={{
                              display: 'inline-flex', alignItems: 'center', gap: 4,
                              fontSize: '0.66rem', fontWeight: 700,
                              padding: '2px 8px', borderRadius: 8,
                              background: '#fef3c7', color: '#92400e',
                              border: '1px solid #fcd34d',
                            }} title={`Grupo #${v.groupId}`}>
                              <span style={{ opacity: 0.7, fontSize: 9 }}>📁</span>
                              {label}
                            </span>
                          );
                        })()}
                      </TableCell>
                      <TableCell>
                        <span className={classes.statusBadge} style={{ background: st.bg, color: st.color }}>
                          <FiberManualRecordIcon style={{ fontSize: 7 }} />
                          {t(lang, v.status)}
                        </span>
                      </TableCell>
                      <TableCell>
                        {v.driverName ? (
                          <Box
                            onClick={(e) => { e.stopPropagation(); setPairDialog({ vehicle: v }); }}
                            style={{
                              display: 'flex', alignItems: 'center', gap: 8,
                              cursor: 'pointer', padding: '4px 6px', margin: '-4px -6px',
                              borderRadius: 8, transition: 'background 0.12s',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--fleet-row-even-hover, #f1f5f9)'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                            title={lang === 'pt' ? 'Ver detalhe completo' : 'View full details'}
                          >
                            <Box style={{
                              width: 28, height: 28, borderRadius: '50%',
                              background: colorFromName(v.driverName),
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                              color: '#fff', fontSize: '0.66rem', fontWeight: 800,
                              flexShrink: 0,
                            }}>
                              {initials(v.driverName)}
                            </Box>
                            <Box style={{ minWidth: 0, flex: 1 }}>
                              <Typography style={{
                                fontSize: '0.76rem', fontWeight: 700, color: 'var(--fleet-strong, #0f172a)',
                                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                              }}>
                                {v.driverName}
                              </Typography>
                              <Box style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 1 }}>
                                {v.driverPhone && (
                                  <a
                                    href={`tel:${v.driverPhone}`}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      fontSize: '0.62rem', color: '#2563eb', fontWeight: 600,
                                      textDecoration: 'none',
                                    }}
                                  >
                                    📞 {v.driverPhone}
                                  </a>
                                )}
                                {v.tachoCard != null && (
                                  <span style={{
                                    fontSize: '0.52rem', fontWeight: 700,
                                    background: v.tachoCard ? '#dcfce7' : '#fef2f2',
                                    color: v.tachoCard ? '#16a34a' : '#dc2626',
                                    padding: '1px 6px', borderRadius: 3,
                                    textTransform: 'uppercase', letterSpacing: '0.03em',
                                  }} title={v.tachoCard
                                    ? (lang === 'pt' ? 'Cartão tacógrafo inserido' : 'Tacho card inserted')
                                    : (lang === 'pt' ? 'Sem cartão tacógrafo' : 'No tacho card')}>
                                    {v.tachoCard ? '✓ Cartão' : '✕ S/Cartão'}
                                  </span>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        ) : (
                          <Box style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <Box style={{
                              width: 28, height: 28, borderRadius: '50%',
                              background: 'var(--fleet-chip-active-bg, #f1f5f9)',
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                              color: 'var(--fleet-muted2, #94a3b8)', fontSize: '0.66rem',
                            }}>?</Box>
                            <span style={{ color: 'var(--fleet-muted2, #94a3b8)', fontSize: '0.72rem', fontStyle: 'italic' }}>
                              {lang === 'pt' ? 'Sem motorista' : 'No driver'}
                            </span>
                          </Box>
                        )}
                      </TableCell>
                      <TableCell>
                        {v.lastUpdate ? (
                          <Box>
                            <Typography style={{ fontSize: '0.74rem', color: 'var(--fleet-text, #334155)', fontWeight: 600 }}>
                              {new Date(v.lastUpdate).toLocaleTimeString(lang === 'pt' ? 'pt-PT' : 'en-GB', { hour: '2-digit', minute: '2-digit' })}
                            </Typography>
                            <Typography style={{ fontSize: '0.62rem', color: 'var(--fleet-muted2, #94a3b8)' }}>
                              {new Date(v.lastUpdate).toLocaleDateString(lang === 'pt' ? 'pt-PT' : 'en-GB', { day: '2-digit', month: '2-digit' })}
                            </Typography>
                          </Box>
                        ) : (
                          <span style={{ color: 'var(--fleet-muted2, #cbd5e1)' }}>—</span>
                        )}
                      </TableCell>
                      <TableCell align="right">
                        <Box className={classes.speedText} style={{ justifyContent: 'flex-end', color: v.speed > 0 ? '#16a34a' : 'var(--fleet-muted2, #94a3b8)' }}>
                          {v.speed > 0 && <SpeedIcon style={{ fontSize: 14 }} />}
                          {v.speed > 0 ? `${Math.round(v.speed)} km/h` : '—'}
                        </Box>
                      </TableCell>
                      <TableCell align="right">
                        <Box style={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                          {v.position && (
                            <Tooltip title={lang === 'pt' ? 'Ver no mapa' : 'View on map'}>
                              <IconButton size="small" onClick={() => {
                                dispatch(navigateTo('planner'));
                                setTimeout(() => {
                                  window.dispatchEvent(new CustomEvent('focusVehicle', { detail: { id: v.id, lat: v.position?.latitude, lng: v.position?.longitude } }));
                                  window.__fromDriversScreen = true;
                                }, 300);
                              }} style={{ padding: 4, color: 'var(--fleet-muted, #475569)' }}>
                                <RoomIcon style={{ fontSize: 16 }} />
                              </IconButton>
                            </Tooltip>
                          )}
                          {/* Histórico de veículos — módulo `vehicle_history`.
                              Este botão é o ÚNICO ponto de entrada (dispara o
                              evento que abre o painel de replay no mapa), por
                              isso gateá-lo aqui basta. */}
                          {v.position && (
                            <ModuleGate module="vehicle_history">
                              <Tooltip title={lang === 'pt' ? 'Ver histórico' : 'View history'}>
                                <IconButton size="small" onClick={() => {
                                  dispatch(navigateTo('planner'));
                                  window.__fromDriversScreen = true;
                                  setTimeout(() => {
                                    window.dispatchEvent(new CustomEvent('vehicleHistory', { detail: { id: v.id, plate: v.plate } }));
                                  }, 300);
                                }} style={{ padding: 4, color: 'var(--fleet-muted, #475569)' }}>
                                  <HistoryIcon style={{ fontSize: 16 }} />
                                </IconButton>
                              </Tooltip>
                            </ModuleGate>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {pagedVehicles.length < filtered.length && (
          <Box
            style={{ textAlign: 'center', padding: '12px 0', cursor: 'pointer', borderTop: '1px solid var(--fleet-border-soft, #f1f5f9)' }}
            onClick={() => setPage(p => p + 1)}
          >
            <Typography style={{ fontSize: '0.78rem', fontWeight: 700, color: 'var(--fleet-strong, #0f172a)' }}>
              {lang === 'pt' ? `Carregar mais (${filtered.length - pagedVehicles.length} restantes)` : `Load more (${filtered.length - pagedVehicles.length} remaining)`}
            </Typography>
          </Box>
        )}
      </Paper>
      </>)}

      {/* Dialog: filtrar grupos EcooGPS visíveis no Planner */}
      <Dialog
        open={groupsOpen}
        onClose={() => !groupsSaving && setGroupsOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 18,
            overflow: 'hidden',
            boxShadow: gp.shadow,
            background: gp.paper,
            border: `1px solid ${gp.border}`,
          },
        }}
      >
        {/* Cabeçalho do diálogo — identidade (ícone + título) à esquerda,
            fechar à direita. Linha de ações fica logo abaixo. */}
        <Box style={{
          padding: '18px 24px 14px',
          background: gp.paper,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
          borderBottom: `1px solid ${gp.border}`,
        }}>
          <Box style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
            <Box style={{
              width: 42, height: 42, borderRadius: 12, flexShrink: 0,
              background: 'linear-gradient(135deg,#eab308,#ca8a04)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 6px 16px rgba(202,138,4,0.32)',
            }}>
              <GroupWorkIcon style={{ fontSize: 22, color: '#fff' }} />
            </Box>
            <Box style={{ minWidth: 0 }}>
              <Typography style={{ fontSize: '1.15rem', fontWeight: 800, color: gp.text, letterSpacing: '-0.01em', lineHeight: 1.15 }}>
                Grupos EcooGPS
              </Typography>
              <Typography style={{ fontSize: '0.76rem', color: gp.textMute, marginTop: 1 }}>
                Escolhe que grupos aparecem no mapa, frota, despacho e motoristas.
              </Typography>
            </Box>
          </Box>
          <IconButton
            size="small"
            onClick={() => !groupsSaving && setGroupsOpen(false)}
            style={{ color: gp.textMute, padding: 6, flexShrink: 0 }}
          >
            <CloseIcon style={{ fontSize: 20 }} />
          </IconButton>
        </Box>

        {/* Barra de ações em lote */}
        <Box style={{
          padding: '14px 24px 0',
          background: gp.paper,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
        }}>
          <Button
            onClick={saveGroups}
            disabled={groupsSaving || groupsLoading}
            variant="contained"
            startIcon={<CheckIcon style={{ fontSize: 16 }} />}
            style={{
              textTransform: 'uppercase', fontWeight: 700, fontSize: '0.72rem',
              padding: '8px 18px', borderRadius: 10, letterSpacing: 0.4,
              background: groupsSaving ? gp.textFaint : 'linear-gradient(135deg,#eab308,#ca8a04)',
              color: '#fff', boxShadow: '0 4px 12px rgba(202,138,4,0.32)',
            }}
          >
            {groupsSaving ? 'A guardar…' : 'Aplicar filtro'}
          </Button>
          <Box style={{ display: 'flex', gap: 8 }}>
            {[
              { fn: selectAllGroups, icon: <CheckIcon style={{ fontSize: 14 }} />, label: 'Tudo' },
              { fn: clearGroups, icon: <CloseIcon style={{ fontSize: 14 }} />, label: 'Limpar' },
              { fn: invertGroups, icon: <FilterListIcon style={{ fontSize: 14 }} />, label: 'Inverter' },
            ].map(b => (
              <Button
                key={b.label}
                onClick={b.fn}
                variant="outlined"
                startIcon={b.icon}
                style={{
                  textTransform: 'uppercase', fontWeight: 700, fontSize: '0.68rem',
                  padding: '6px 14px', borderRadius: 10, letterSpacing: 0.4,
                  color: gp.btnText, borderColor: gp.btnBorder, background: gp.btnBg,
                }}
              >
                {b.label}
              </Button>
            ))}
          </Box>
        </Box>

        <DialogContent style={{ padding: '16px 24px 24px', background: gp.paper, overflow: 'hidden' }}>
          {/* Card-tabela */}
          <Box style={{
            background: gp.surface, borderRadius: 16,
            boxShadow: gp.shadow, border: `1px solid ${gp.border}`,
            overflow: 'hidden',
            display: 'flex', flexDirection: 'column',
            maxHeight: 560,
          }}>
            {/* Header do card — stats à esquerda, pesquisa à direita */}
            <Box style={{
              padding: '16px 22px',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              gap: 16, flexWrap: 'wrap',
              borderBottom: `1px solid ${gp.borderSoft}`,
            }}>
              <Box style={{ display: 'flex', gap: 8 }}>
                <Box style={{
                  padding: '7px 14px', borderRadius: 12,
                  background: gp.accentSoft, border: `1px solid ${gp.accentBorder}`,
                  display: 'flex', alignItems: 'center', gap: 9,
                }}>
                  <VisibilityIcon style={{ fontSize: 16, color: gp.accentText }} />
                  <Box>
                    <Typography style={{ fontSize: '0.58rem', color: gp.accentText, textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 800 }}>
                      Visíveis
                    </Typography>
                    <Typography style={{ fontSize: '0.95rem', fontWeight: 800, color: gp.accentText, lineHeight: 1.1, fontFamily: 'ui-monospace, Menlo, monospace' }}>
                      {groupsSelected.size}<span style={{ fontSize: '0.65rem', opacity: 0.7, fontWeight: 500 }}> / {groupsList.length}</span>
                    </Typography>
                  </Box>
                </Box>
                <Box style={{
                  padding: '7px 14px', borderRadius: 12,
                  background: gp.iconOffBg, border: `1px solid ${gp.border}`,
                  display: 'flex', alignItems: 'center', gap: 9,
                }}>
                  <LocalShippingIcon style={{ fontSize: 16, color: gp.textMute }} />
                  <Box>
                    <Typography style={{ fontSize: '0.58rem', color: gp.textMute, textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 800 }}>
                      Viaturas
                    </Typography>
                    <Typography style={{ fontSize: '0.95rem', fontWeight: 800, color: gp.text, lineHeight: 1.1, fontFamily: 'ui-monospace, Menlo, monospace' }}>
                      {groupsList.filter(g => groupsSelected.has(g.id)).reduce((s, g) => s + g.deviceCount, 0)}
                      <span style={{ fontSize: '0.65rem', color: gp.textMute, fontWeight: 500 }}> / {groupsDeviceCount}</span>
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* Search */}
              <Box style={{
                display: 'flex', alignItems: 'center', gap: 6,
                padding: '7px 12px', background: gp.surfaceAlt, borderRadius: 10,
                border: `1px solid ${gp.border}`, width: 240,
              }}>
                <SearchIcon style={{ fontSize: 16, color: gp.textFaint }} />
                <input
                  type="text"
                  placeholder="Procurar grupo…"
                  value={groupsSearch}
                  onChange={e => setGroupsSearch(e.target.value)}
                  style={{
                    flex: 1, border: 'none', outline: 'none', background: 'transparent',
                    fontSize: '0.8rem', color: gp.text, fontFamily: 'inherit',
                  }}
                />
                {groupsSearch && (
                  <IconButton size="small" onClick={() => setGroupsSearch('')} style={{ padding: 2 }}>
                    <CloseIcon style={{ fontSize: 13, color: gp.textFaint }} />
                  </IconButton>
                )}
              </Box>
            </Box>

            {/* Tabela */}
            <Box style={{ overflow: 'auto', flex: 1 }}>
              {groupsLoading ? (
                <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 60, gap: 12 }}>
                  <CircularProgress size={32} style={{ color: gp.accent }} />
                  <Typography style={{ fontSize: '0.78rem', color: gp.textMute }}>A carregar grupos…</Typography>
                </Box>
              ) : (
                (() => {
                  const q = groupsSearch.trim().toLowerCase();
                  const filt = q ? groupsList.filter(g => g.name.toLowerCase().includes(q)) : groupsList;
                  const allFiltSelected = filt.length > 0 && filt.every(g => groupsSelected.has(g.id));
                  const someFiltSelected = filt.some(g => groupsSelected.has(g.id));
                  const toggleAllFilt = () => {
                    setGroupsSelected(prev => {
                      const next = new Set(prev);
                      if (allFiltSelected) filt.forEach(g => next.delete(g.id));
                      else filt.forEach(g => next.add(g.id));
                      return next;
                    });
                  };
                  return (
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell padding="checkbox" style={{ borderBottom: `1px solid ${gp.border}`, paddingLeft: 26, background: gp.surfaceAlt }}>
                            <Checkbox
                              size="small"
                              checked={allFiltSelected}
                              indeterminate={!allFiltSelected && someFiltSelected}
                              onChange={toggleAllFilt}
                              style={{ color: gp.accent, padding: 4 }}
                            />
                          </TableCell>
                          {['Grupo', 'Estado', 'Viaturas'].map(h => (
                            <TableCell key={h} style={{
                              borderBottom: `1px solid ${gp.border}`,
                              fontSize: '0.65rem', fontWeight: 800, color: gp.textMute,
                              textTransform: 'uppercase', letterSpacing: 0.6,
                              padding: '12px 16px', background: gp.surfaceAlt,
                            }}>
                              {h}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filt.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={4} style={{ borderBottom: 'none', padding: 40, textAlign: 'center' }}>
                              <GroupWorkIcon style={{ fontSize: 36, color: gp.textFaint }} />
                              <Typography style={{ fontSize: '0.82rem', color: gp.textFaint, marginTop: 8 }}>
                                {q ? `Sem resultados para "${groupsSearch}".` : 'Nenhum grupo encontrado no EcooGPS.'}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        ) : filt.map(g => {
                          const on = groupsSelected.has(g.id);
                          return (
                            <TableRow
                              key={g.id}
                              hover
                              onClick={() => toggleGroup(g.id)}
                              style={{ cursor: 'pointer', background: on ? gp.rowOn : 'transparent' }}
                            >
                              <TableCell padding="checkbox" style={{ borderBottom: `1px solid ${gp.borderSoft}`, paddingLeft: 26 }}>
                                <Checkbox
                                  size="small"
                                  checked={on}
                                  onClick={e => { e.stopPropagation(); toggleGroup(g.id); }}
                                  style={{ color: on ? gp.accent : gp.textFaint, padding: 4 }}
                                />
                              </TableCell>
                              <TableCell style={{
                                borderBottom: `1px solid ${gp.borderSoft}`,
                                padding: '14px 16px',
                              }}>
                                <Box style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                  <Box style={{
                                    width: 32, height: 32, borderRadius: 8,
                                    background: on ? gp.iconOnBg : gp.iconOffBg,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    flexShrink: 0,
                                  }}>
                                    <GroupWorkIcon style={{ fontSize: 16, color: on ? gp.accentText : gp.textFaint }} />
                                  </Box>
                                  <Typography style={{
                                    fontSize: '0.86rem', fontWeight: 600,
                                    color: on ? gp.text : gp.textMute,
                                  }}>
                                    {g.name}
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell style={{ borderBottom: `1px solid ${gp.borderSoft}`, padding: '14px 16px' }}>
                                <Box style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                  {on ? (
                                    <>
                                      <Box style={{
                                        width: 18, height: 18, borderRadius: '50%',
                                        background: gp.iconOnBg, border: `1.5px solid ${gp.accentBorder}`,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                      }}>
                                        <CheckIcon style={{ fontSize: 11, color: gp.accentText }} />
                                      </Box>
                                      <Typography style={{ fontSize: '0.78rem', fontWeight: 600, color: gp.accentText }}>
                                        Visível
                                      </Typography>
                                    </>
                                  ) : (
                                    <>
                                      <Box style={{
                                        width: 18, height: 18, borderRadius: '50%',
                                        background: gp.iconOffBg, border: `1.5px solid ${gp.border}`,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                      }}>
                                        <VisibilityOffIcon style={{ fontSize: 10, color: gp.textMute }} />
                                      </Box>
                                      <Typography style={{ fontSize: '0.78rem', fontWeight: 600, color: gp.textMute }}>
                                        Escondido
                                      </Typography>
                                    </>
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell style={{ borderBottom: `1px solid ${gp.borderSoft}`, padding: '14px 16px' }}>
                                <Typography style={{
                                  fontSize: '0.86rem', fontWeight: 700,
                                  color: on ? gp.text : gp.textMute,
                                }}>
                                  {g.deviceCount}
                                  <span style={{ fontSize: '0.7rem', fontWeight: 500, color: gp.textFaint, marginLeft: 4 }}>
                                    {g.deviceCount === 1 ? 'viatura' : 'viaturas'}
                                  </span>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  );
                })()
              )}
            </Box>

            {/* Footer do card */}
            <Box style={{
              padding: '14px 26px', borderTop: `1px solid ${gp.borderSoft}`,
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              background: gp.surfaceAlt,
            }}>
              <Typography style={{ fontSize: '0.72rem', color: gp.textFaint }}>
                Vazio ou tudo seleccionado = sem filtro aplicado
              </Typography>
              <Button
                onClick={() => setGroupsOpen(false)}
                disabled={groupsSaving}
                style={{
                  textTransform: 'none', fontWeight: 600, fontSize: '0.78rem',
                  color: gp.textMute, padding: '4px 12px',
                }}
              >
                Cancelar
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Dialog: detalhe da associação Motorista ↔ Veículo. Mostra ambos os
          lados num único cartão com atalhos para o mapa, histórico e
          chamada telefónica. */}
      <Dialog
        open={!!pairDialog}
        onClose={() => setPairDialog(null)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 16, overflow: 'hidden',
            boxShadow: '0 24px 64px rgba(28,28,28,0.22)',
          },
        }}
      >
        {pairDialog && (() => {
          const v = pairDialog.vehicle;
          const stMeta = STATUS_STYLES[v.status] || STATUS_STYLES.off;
          const tachoStatus = v.tachoCard === true
            ? { label: lang === 'pt' ? 'Cartão inserido' : 'Card inserted', color: '#16a34a', bg: '#dcfce7' }
            : v.tachoCard === false
              ? { label: lang === 'pt' ? 'Sem cartão' : 'No card', color: '#dc2626', bg: '#fef2f2' }
              : null;
          return (
            <>
              {/* Header com gradient */}
              <Box style={{
                padding: '20px 24px 16px',
                background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 60%, #2563eb 100%)',
                color: '#fff', position: 'relative',
              }}>
                <Box style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                  <Box style={{
                    width: 52, height: 52, borderRadius: 14,
                    background: colorFromName(v.driverName),
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontSize: '1.1rem', fontWeight: 800,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                    border: '2px solid rgba(255,255,255,0.4)',
                  }}>
                    {initials(v.driverName)}
                  </Box>
                  <Box style={{ flex: 1, minWidth: 0 }}>
                    <Typography style={{ fontSize: '1.1rem', fontWeight: 800, letterSpacing: '-0.01em' }}>
                      {v.driverName || (lang === 'pt' ? 'Sem motorista' : 'No driver')}
                    </Typography>
                    <Typography style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.8)', marginTop: 2 }}>
                      {lang === 'pt' ? 'Associação Motorista ↔ Veículo' : 'Driver ↔ Vehicle pairing'}
                    </Typography>
                  </Box>
                  <IconButton size="small" onClick={() => setPairDialog(null)} style={{ color: 'rgba(255,255,255,0.85)' }}>
                    <CloseIcon style={{ fontSize: 20 }} />
                  </IconButton>
                </Box>
              </Box>

              {/* Corpo — 2 cartões lado a lado */}
              <Box style={{ padding: 18, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                {/* Cartão Motorista */}
                <Box style={{
                  padding: 14, borderRadius: 12,
                  background: '#fff', border: '1px solid #e2e8f0',
                }}>
                  <Typography style={{
                    fontSize: '0.62rem', fontWeight: 800, color: '#64748b',
                    textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8,
                  }}>
                    {lang === 'pt' ? '👤 Motorista' : '👤 Driver'}
                  </Typography>
                  <Typography style={{ fontSize: '0.9rem', fontWeight: 700, color: '#0f172a' }}>
                    {v.driverName || '—'}
                  </Typography>
                  {v.driverPhone && (
                    <Box style={{ marginTop: 8 }}>
                      <Typography style={{ fontSize: '0.6rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.3 }}>
                        {lang === 'pt' ? 'Telefone' : 'Phone'}
                      </Typography>
                      <a href={`tel:${v.driverPhone}`} style={{
                        fontSize: '0.86rem', fontWeight: 700, color: '#2563eb',
                        textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4,
                      }}>
                        📞 {v.driverPhone}
                      </a>
                    </Box>
                  )}
                  {tachoStatus && (
                    <Box style={{ marginTop: 8 }}>
                      <Typography style={{ fontSize: '0.6rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.3 }}>
                        {lang === 'pt' ? 'Cartão tacógrafo' : 'Tacho card'}
                      </Typography>
                      <Box style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 2,
                        padding: '3px 10px', borderRadius: 6,
                        background: tachoStatus.bg, color: tachoStatus.color,
                        fontSize: '0.7rem', fontWeight: 700,
                      }}>
                        {tachoStatus.label}
                      </Box>
                    </Box>
                  )}
                </Box>

                {/* Cartão Veículo */}
                <Box style={{
                  padding: 14, borderRadius: 12,
                  background: '#fff', border: '1px solid #e2e8f0',
                }}>
                  <Typography style={{
                    fontSize: '0.62rem', fontWeight: 800, color: '#64748b',
                    textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8,
                  }}>
                    {lang === 'pt' ? '🚛 Veículo' : '🚛 Vehicle'}
                  </Typography>
                  <Typography style={{ fontSize: '0.9rem', fontWeight: 800, color: '#0f172a', fontFamily: 'ui-monospace, Menlo, monospace' }}>
                    {v.plate || v.name || '—'}
                  </Typography>
                  <Typography style={{ fontSize: '0.7rem', color: '#64748b', marginTop: 2 }}>
                    {v.type || (lang === 'pt' ? 'Sem tipo' : 'No type')}
                  </Typography>
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8 }}>
                    <span style={{
                      display: 'inline-flex', alignItems: 'center', gap: 4,
                      fontSize: '0.62rem', fontWeight: 700,
                      padding: '2px 8px', borderRadius: 8,
                      background: stMeta.bg, color: stMeta.color,
                    }}>
                      <FiberManualRecordIcon style={{ fontSize: 7 }} />
                      {t(lang, v.status)}
                    </span>
                    {v.speed > 0 && (
                      <span style={{ fontSize: '0.66rem', color: '#16a34a', fontWeight: 700 }}>
                        {Math.round(v.speed)} km/h
                      </span>
                    )}
                  </Box>
                  {resolveGroupLabel(v) && (
                    <Box style={{ marginTop: 8 }}>
                      <Typography style={{ fontSize: '0.6rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.3 }}>
                        {lang === 'pt' ? 'Grupo' : 'Group'}
                      </Typography>
                      <span style={{
                        display: 'inline-block', marginTop: 2,
                        fontSize: '0.66rem', fontWeight: 700,
                        padding: '2px 8px', borderRadius: 8,
                        background: '#fef3c7', color: '#92400e',
                        border: '1px solid #fcd34d',
                      }}>
                        📁 {resolveGroupLabel(v)}
                      </span>
                    </Box>
                  )}
                  {v.lastUpdate && (
                    <Box style={{ marginTop: 8 }}>
                      <Typography style={{ fontSize: '0.6rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.3 }}>
                        {lang === 'pt' ? 'Última actividade' : 'Last update'}
                      </Typography>
                      <Typography style={{ fontSize: '0.72rem', color: '#334155', fontWeight: 600 }}>
                        {new Date(v.lastUpdate).toLocaleString(lang === 'pt' ? 'pt-PT' : 'en-GB', {
                          day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
                        })}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>

              {/* Acções */}
              <Box style={{
                padding: '12px 18px', borderTop: '1px solid #e2e8f0',
                background: '#fafaf9',
                display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end',
              }}>
                {v.driverPhone && (
                  <Button
                    href={`tel:${v.driverPhone}`}
                    size="small"
                    variant="outlined"
                    style={{
                      textTransform: 'none', fontWeight: 700, fontSize: '0.74rem',
                      color: '#2563eb', borderColor: '#bfdbfe',
                    }}
                  >
                    📞 {lang === 'pt' ? 'Ligar' : 'Call'}
                  </Button>
                )}
                {v.position && (
                  <Button
                    onClick={() => {
                      setPairDialog(null);
                      dispatch(navigateTo('planner'));
                      setTimeout(() => {
                        window.dispatchEvent(new CustomEvent('focusVehicle', { detail: { id: v.id, lat: v.position?.latitude, lng: v.position?.longitude } }));
                        window.__fromDriversScreen = true;
                      }, 300);
                    }}
                    size="small"
                    variant="contained"
                    style={{
                      textTransform: 'none', fontWeight: 700, fontSize: '0.74rem',
                      background: '#1e40af', color: '#fff',
                      boxShadow: '0 2px 6px rgba(30,64,175,0.28)',
                    }}
                  >
                    🗺 {lang === 'pt' ? 'Ver no mapa' : 'View on map'}
                  </Button>
                )}
                <Button
                  onClick={() => setPairDialog(null)}
                  size="small"
                  style={{
                    textTransform: 'none', fontWeight: 600, fontSize: '0.74rem',
                    color: '#64748b',
                  }}
                >
                  {lang === 'pt' ? 'Fechar' : 'Close'}
                </Button>
              </Box>
            </>
          );
        })()}
      </Dialog>
    </Box>
  );
}

export default FleetView;
